module.exports = __webpack_public_path__ + "img/GMP_2.81aa562c.jpg";